import { z } from 'zod';

export const projectFormSchema = z.object({
  name: z.string()
    .min(1, 'El nombre es requerido')
    .max(255, 'El nombre debe tener máximo 255 caracteres'),
  reference_code: z.string()
    .max(100, 'El código de referencia debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  customer_id: z.string()
    .uuid('Debe ser un UUID válido')
    .optional()
    .or(z.literal('')),
  description: z.string()
    .max(2000, 'La descripción debe tener máximo 2000 caracteres')
    .optional()
    .or(z.literal('')),
  status: z.enum(['planning', 'active', 'paused', 'completed', 'cancelled'])
    .default('planning'),
  start_date: z.string()
    .optional()
    .or(z.literal('')),
  end_date: z.string()
    .optional()
    .or(z.literal('')),
  estimated_hours: z.number()
    .min(0, 'Las horas estimadas deben ser mayores o iguales a 0')
    .optional(),
  actual_hours: z.number()
    .min(0, 'Las horas reales deben ser mayores o iguales a 0')
    .default(0),
  budget: z.number()
    .min(0, 'El presupuesto debe ser mayor o igual a 0')
    .optional(),
  notes: z.string()
    .max(2000, 'Las notas deben tener máximo 2000 caracteres')
    .optional()
    .or(z.literal('')),
  document_url: z.string()
    .url('Debe ser una URL válida')
    .max(500, 'La URL del documento debe tener máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  is_active: z.boolean().default(true),
});

export type ProjectFormData = z.infer<typeof projectFormSchema>;
